import { Routes, Route, RoutesProps } from "react-router-dom";

import React, { Suspense } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";
import DeliveryBoyPayout from "../components/DeliveryBoy/DeliveryBoyPayout";
import DeliveryBoyPayoutDetail from "../components/DeliveryBoy/DeliveryBoyPayoutDetail";
import DeliveryBoyPayoutMonth from "../components/DeliveryBoy/DeliveryBoyPayoutMonth";
import UserSubscription from "../components/UserSubscription/userSubscription";
import OrdersRefund from "../components/Order/OrdersRefund";

const Navigation = () => {
  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));

  const ForgotPassword = React.lazy(
    () => import("../components/Login/ForgotPassword")
  );

  const Otp = React.lazy(() => import("../components/Login/Otp"));

  const CreateNewPassword = React.lazy(
    () => import("../components/Login/CreateNewPassword")
  );

  const MyProfile = React.lazy(() => import("../components/Profile/Profile"));

  const Dashboard = React.lazy(
    () => import("../components/DashBoard/Dashboard")
  );
  const PageElements = React.lazy(
    () => import("../components/PageElements/PageElements")
  );

  const Roles = React.lazy(() => import("../components/Roles/Role"));

  const AddRoles = React.lazy(() => import("../components/Roles/AddRole"));

  const AdminUsers = React.lazy(
    () => import("../components/AdminUsers/AdminUser")
  );
  const AddAdminUser = React.lazy(
    () => import("../components/AdminUsers/AddAdminUser")
  );

  const Tag = React.lazy(() => import("../components/Tags/Tag"));

  const Restaurant = React.lazy(
    () => import("../components/Restaurant/Restaurant")
  );

  const AddRestaurant = React.lazy(
    () => import("../components/Restaurant/AddRestaurant")
  );

  const RestaurantItem = React.lazy(
    () => import("../components/Restaurant/RestaurantItem")
  );

  const AddRestaurantItem = React.lazy(
    () => import("../components/Restaurant/AddRestaurantItem")
  );

  const ImportRestaurantItem = React.lazy(
    () => import("../components/Restaurant/ImportRestaurantItem")
  );

  const ImportRestaurantItemLog = React.lazy(
    () => import("../components/Restaurant/ImportLog")
  );

  const RestaurantType = React.lazy(
    () => import("../components/RestaurantType/RestaurantType")
  );

  const AddRestaurantType = React.lazy(
    () => import("../components/RestaurantType/AddRestaurantType")
  );

  const RestaurantCategory = React.lazy(
    () => import("../components/RestaurantCategory/RestaurantCategory")
  );

  const AddRestaurantCategory = React.lazy(
    () => import("../components/RestaurantCategory/AddRestaurantCategory")
  );

  const ScheduleRestaurant = React.lazy(
    () => import("../components/Restaurant/ScheduleRestaurant")
  );

  const Tax = React.lazy(() => import("../components/Tax/Tax"));

  const Vendor = React.lazy(() => import("../components/Vendor/Vendor"));

  const AddVendor = React.lazy(() => import("../components/Vendor/AddVendor"));

  const ViewVendor = React.lazy(
    () => import("../components/Vendor/ViewVendor")
  );

  const ScheduleVendor = React.lazy(
    () => import("../components/Vendor/ScheduleVendor")
  );

  const Customer = React.lazy(() => import("../components/Customer/Customer"));

  const ViewCustomer = React.lazy(
    () => import("../components/Customer/ViewCustomer")
  );

  const DeliveryBoy = React.lazy(
    () => import("../components/DeliveryBoy/DeliveryBoy")
  );

  const AddDeliveryBoy = React.lazy(
    () => import("../components/DeliveryBoy/AddDeliveryBoy")
  );

  const ViewDeliveryBoy = React.lazy(
    () => import("../components/DeliveryBoy/ViewDeliveryBoy")
  );

  const DeliveryBoyProduct = React.lazy(
    () => import("../components/DeliveryBoyProduct/Product")
  );

  const AddDeliveryBoyProduct = React.lazy(
    () => import("../components/DeliveryBoyProduct/AddProduct")
  );

  const DeliveryBoyProductSize = React.lazy(
    () => import("../components/DeliveryBoyProduct/Size")
  );

  const AddDeliveryBoyProductSize = React.lazy(
    () => import("../components/DeliveryBoyProduct/AddSize")
  );

  const DeliveryBoyProductOrder = React.lazy(
    () => import("../components/DeliveryBoyProduct/Order")
  );

  const Service = React.lazy(() => import("../components/Service/Service"));

  const AddService = React.lazy(
    () => import("../components/Service/AddService")
  );

  const Banner = React.lazy(() => import("../components/Banner/Banner"));

  const AddBanner = React.lazy(() => import("../components/Banner/AddBanner"));

  const Offer = React.lazy(() => import("../components/Offer/Offer"));

  const AddOffer = React.lazy(() => import("../components/Offer/AddOffer"));
  const ViewOffer = React.lazy(() => import("../components/Offer/ViewOffer"));

  const Brand = React.lazy(() => import("../components/Brand/Brand"));

  const AddBrand = React.lazy(() => import("../components/Brand/AddBrand"));

  const Expenses = React.lazy(() => import("../components/Expenses/Expenses"));

  const AddExpenses = React.lazy(
    () => import("../components/Expenses/AddExpenses")
  );

  const ExpenseType = React.lazy(
    () => import("../components/ExpenseType/ExpenseType")
  );

  const Report = React.lazy(() => import("../components/Report/Report"));

  const BazaarOrder = React.lazy(
    () => import("../components/Order/BazaarOrder")
  );

  const RestaurantOrder = React.lazy(
    () => import("../components/Order/RestaurantOrder")
  );

  const SerivceOrder = React.lazy(
    () => import("../components/Order/SerivceOrder")
  );

  const Map = React.lazy(() => import("../components/Order/Map"));

  const VendorPayoutWeek = React.lazy(
    () => import("../components/Vendor/VendorPayoutWeek")
  );

  const VendorPayout = React.lazy(
    () => import("../components/Vendor/VendorPayout")
  );

  const VendorPayoutDetail = React.lazy(
    () => import("../components/Vendor/VendorPayoutDetail")
  );

  const Conversation = React.lazy(
    () => import("../components/Chat/Conversation")
  );

  const Chat = React.lazy(() => import("../components/Chat/Chat"));

  const OrderReview = React.lazy(
    () => import("../components/Order/OrderReview")
  );

  const OrderDetail = React.lazy(
    () => import("../components/Order/OrderDetail")
  );

  const StaticPage = React.lazy(
    () => import("../components/StaticPage/StaticPage")
  );

  const AddStaticPage = React.lazy(
    () => import("../components/StaticPage/AddStaticPage")
  );

  const Agreement = React.lazy(
    () => import("../components/Agreement/Agreement")
  );

  const AddAgreement = React.lazy(
    () => import("../components/Agreement/AddAgreement")
  );

  const Pincode = React.lazy(() => import("../components/PinCode/PinCode"));

  const Reason = React.lazy(() => import("../components/Reason/Reason"));

  const Product = React.lazy(() => import("../components/Product/Products"));

  const AddProduct = React.lazy(
    () => import("../components/Product/AddProduct")
  );

  const ProductCategory = React.lazy(
    () => import("../components/Product/ProductCategory")
  );

  const AddProductCategory = React.lazy(
    () => import("../components/Product/AddProductCategory")
  );

  const ProductVariant = React.lazy(
    () => import("../components/Product/ProductVariant")
  );

  const AddProductVariant = React.lazy(
    () => import("../components/Product/AddProductVariant")
  );

  const ImportProductVariant = React.lazy(
    () => import("../components/Product/ImportProductVariant")
  );

  const ImportProductVariantLog = React.lazy(
    () => import("../components/Product/ImportLog")
  );

  const ImportVendorProduct = React.lazy(
    () => import("../components/Vendor/ImportVendorProduct")
  );

  const ImportVendorProductLog = React.lazy(
    () => import("../components/Vendor/ImportLog")
  );

  const ProductAttribute = React.lazy(
    () => import("../components/Product/ProductAttribute")
  );

  const AddProductAttribute = React.lazy(
    () => import("../components/Product/AddProductAttribute")
  );

  const ServiceCategory = React.lazy(
    () => import("../components/Service/ServiceCategory")
  );

  const AddServiceCategory = React.lazy(
    () => import("../components/Service/AddServiceCategory")
  );

  const AppSupport = React.lazy(
    () => import("../components/AppSupport/AppSupport")
  );

  const Setting = React.lazy(() => import("../components/AppSupport/Setting"));

  const AppVersion = React.lazy(
    () => import("../components/AppSupport/AppVersion")
  );

  const Notification = React.lazy(
    () => import("../components/Notification/Notification")
  );
  const AddNotification = React.lazy(
    () => import("../components/Notification/AddNotification")
  );
  const UserNotification = React.lazy(
    () => import("../components/Notification/UserNotification")
  );

  const TimeSlot = React.lazy(() => import("../components/TimeSlot/TimeSlot"));

  const AddTimeSlot = React.lazy(
    () => import("../components/TimeSlot/AddTimeSlot")
  );

  const DeliveryCharges = React.lazy(
    () => import("../components/DeliveryCharges/DeliveryCharges")
  );

  const AddDeliveryCharges = React.lazy(
    () => import("../components/DeliveryCharges/AddDeliveryCharges")
  );

  const CustomerSupport = React.lazy(
    () => import("../components/Support/customer")
  );
  const VendorSupport = React.lazy(
    () => import("../components/Support/vendor")
  );
  const DeliverySupport = React.lazy(
    () => import("../components/Support/delivery")
  );

  const Wallet = React.lazy(() => import("../components/Wallet/Wallet"));

  const AddWallet = React.lazy(() => import("../components/Wallet/AddWallet"));

  return (
    <>
      <div id="main-wraper">
        <Routes>
          {/* Withouth login  */}
          <Route
            path="/login"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <Login />{" "}
              </Suspense>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <ForgotPassword />{" "}
              </Suspense>
            }
          />
          <Route
            path="/otp"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <Otp />{" "}
              </Suspense>
            }
          />

          <Route
            path="/create-new-password"
            element={
              <Suspense fallback={<></>}>
                {" "}
                <CreateNewPassword />{" "}
              </Suspense>
            }
          />

          {/* With login  */}
          <Route
            path="/"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={<Main />}
              />
            }
          >
            <Route
              path="/page-elements"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <PageElements />{" "}
                </Suspense>
              }
            />
            <Route
              path="/dashboard"
              element={
                <Suspense fallback={<></>}>
                  {" "}
                  <Dashboard />{" "}
                </Suspense>
              }
            />
            <Route
              path="/my-profile"
              element={
                <Suspense fallback={<></>}>
                  <MyProfile />
                </Suspense>
              }
            />
            <Route
              path="/roles"
              element={
                <Suspense fallback={<></>}>
                  <Roles />
                </Suspense>
              }
            />
            <Route
              path="/add-role"
              element={
                <Suspense fallback={<></>}>
                  <AddRoles />
                </Suspense>
              }
            />
            <Route
              path="/add-admin-user"
              element={
                <Suspense fallback={<></>}>
                  <AddAdminUser />
                </Suspense>
              }
            />
            <Route
              path="/edit-admin-user"
              element={
                <Suspense fallback={<></>}>
                  <AddAdminUser />
                </Suspense>
              }
            />
            <Route
              path="/admins"
              element={
                <Suspense fallback={<></>}>
                  <AdminUsers />
                </Suspense>
              }
            />
            <Route
              path="/tags"
              element={
                <Suspense fallback={<></>}>
                  <Tag />
                </Suspense>
              }
            />

            <Route
              path="/restaurant"
              element={
                <Suspense fallback={<></>}>
                  <Restaurant />
                </Suspense>
              }
            />

            <Route
              path="/add-restaurant"
              element={
                <Suspense fallback={<></>}>
                  <AddRestaurant />
                </Suspense>
              }
            />

            <Route
              path="/edit-restaurant"
              element={
                <Suspense fallback={<></>}>
                  <AddRestaurant />
                </Suspense>
              }
            />

            <Route
              path="/restaurant-items"
              element={
                <Suspense fallback={<></>}>
                  <RestaurantItem />
                </Suspense>
              }
            />

            <Route
              path="/add-restaurant-item"
              element={
                <Suspense fallback={<></>}>
                  <AddRestaurantItem />
                </Suspense>
              }
            />

            <Route
              path="/edit-restaurant-item"
              element={
                <Suspense fallback={<></>}>
                  <AddRestaurantItem />
                </Suspense>
              }
            />

            <Route
              path="/import-restaurant-item"
              element={
                <Suspense fallback={<></>}>
                  <ImportRestaurantItem />
                </Suspense>
              }
            />

            <Route
              path="/import-restaurant-item-log"
              element={
                <Suspense fallback={<></>}>
                  <ImportRestaurantItemLog />
                </Suspense>
              }
            />

            <Route
              path="/restaurant-types"
              element={
                <Suspense fallback={<></>}>
                  <RestaurantType />
                </Suspense>
              }
            />
            <Route
              path="/add-restaurant-type"
              element={
                <Suspense fallback={<></>}>
                  <AddRestaurantType />
                </Suspense>
              }
            />
            <Route
              path="/edit-restaurant-type"
              element={
                <Suspense fallback={<></>}>
                  <AddRestaurantType />
                </Suspense>
              }
            />
            <Route
              path="/restaurant-categories"
              element={
                <Suspense fallback={<></>}>
                  <RestaurantCategory />
                </Suspense>
              }
            />
            <Route
              path="/add-item-category"
              element={
                <Suspense fallback={<></>}>
                  <AddRestaurantCategory />
                </Suspense>
              }
            />
            <Route
              path="/edit-item-category"
              element={
                <Suspense fallback={<></>}>
                  <AddRestaurantCategory />
                </Suspense>
              }
            />
            <Route
              path="/schedule-restaurant"
              element={
                <Suspense fallback={<></>}>
                  <ScheduleRestaurant />
                </Suspense>
              }
            />
            <Route
              path="/taxes"
              element={
                <Suspense fallback={<></>}>
                  <Tax />
                </Suspense>
              }
            />
            <Route
              path="/vendors"
              element={
                <Suspense fallback={<></>}>
                  <Vendor />
                </Suspense>
              }
            />
            <Route
              path="/add-vendor"
              element={
                <Suspense fallback={<></>}>
                  <AddVendor />
                </Suspense>
              }
            />

            <Route
              path="/edit-vendor"
              element={
                <Suspense fallback={<></>}>
                  <AddVendor />
                </Suspense>
              }
            />

            <Route
              path="/view-vendor"
              element={
                <Suspense fallback={<></>}>
                  <ViewVendor />
                </Suspense>
              }
            />

            <Route
              path="/import-vendor-product"
              element={
                <Suspense fallback={<></>}>
                  <ImportVendorProduct />
                </Suspense>
              }
            />

            <Route
              path="/import-vendor-product-log"
              element={
                <Suspense fallback={<></>}>
                  <ImportVendorProductLog />
                </Suspense>
              }
            />

            <Route
              path="/schedule-vendor"
              element={
                <Suspense fallback={<></>}>
                  <ScheduleVendor />
                </Suspense>
              }
            />

            <Route
              path="/vendor-payout-weeks"
              element={
                <Suspense fallback={<></>}>
                  <VendorPayoutWeek />
                </Suspense>
              }
            />

            <Route
              path="/vendor-payouts"
              element={
                <Suspense fallback={<></>}>
                  <VendorPayout />
                </Suspense>
              }
            />

            <Route
              path="/vendor-payout-detail"
              element={
                <Suspense fallback={<></>}>
                  <VendorPayoutDetail />
                </Suspense>
              }
            />

            <Route
              path="/delivery-boy-months"
              element={
                <Suspense fallback={<></>}>
                  <DeliveryBoyPayoutMonth />
                </Suspense>
              }
            />

            <Route
              path="/delivery-boy-payouts"
              element={
                <Suspense fallback={<></>}>
                  <DeliveryBoyPayout />
                </Suspense>
              }
            />

            <Route
              path="/delivery-boy-payout-detail"
              element={
                <Suspense fallback={<></>}>
                  <DeliveryBoyPayoutDetail />
                </Suspense>
              }
            />

            <Route
              path="/conversations"
              element={
                <Suspense fallback={<></>}>
                  <Conversation />
                </Suspense>
              }
            />
            <Route
              path="/chat"
              element={
                <Suspense fallback={<></>}>
                  <Chat />
                </Suspense>
              }
            />

            <Route
              path="/customers"
              element={
                <Suspense fallback={<></>}>
                  <Customer />
                </Suspense>
              }
            />
            <Route
              path="/view-customer"
              element={
                <Suspense fallback={<></>}>
                  <ViewCustomer />
                </Suspense>
              }
            />

            <Route
              path="/delivery-boys"
              element={
                <Suspense fallback={<></>}>
                  <DeliveryBoy />
                </Suspense>
              }
            />
            <Route
              path="/add-delivery-boy"
              element={
                <Suspense fallback={<></>}>
                  <AddDeliveryBoy />
                </Suspense>
              }
            />
            <Route
              path="/edit-delivery-boy"
              element={
                <Suspense fallback={<></>}>
                  <AddDeliveryBoy />
                </Suspense>
              }
            />
            <Route
              path="/view-delivery-boy"
              element={
                <Suspense fallback={<></>}>
                  <ViewDeliveryBoy />
                </Suspense>
              }
            />
            <Route
              path="/delivery-boy-products"
              element={
                <Suspense fallback={<></>}>
                  <DeliveryBoyProduct />
                </Suspense>
              }
            />
            <Route
              path="/add-delivery-boy-product"
              element={
                <Suspense fallback={<></>}>
                  <AddDeliveryBoyProduct />
                </Suspense>
              }
            />
            <Route
              path="/edit-delivery-boy-product"
              element={
                <Suspense fallback={<></>}>
                  <AddDeliveryBoyProduct />
                </Suspense>
              }
            />

            <Route
              path="/delivery-boy-product-sizes"
              element={
                <Suspense fallback={<></>}>
                  <DeliveryBoyProductSize />
                </Suspense>
              }
            />

            <Route
              path="/add-delivery-boy-product-size"
              element={
                <Suspense fallback={<></>}>
                  <AddDeliveryBoyProductSize />
                </Suspense>
              }
            />

            <Route
              path="/edit-delivery-boy-product-size"
              element={
                <Suspense fallback={<></>}>
                  <AddDeliveryBoyProductSize />
                </Suspense>
              }
            />

            <Route
              path="/delivery-boy-orders"
              element={
                <Suspense fallback={<></>}>
                  <DeliveryBoyProductOrder />
                </Suspense>
              }
            />

            <Route
              path="/services"
              element={
                <Suspense fallback={<></>}>
                  <Service />
                </Suspense>
              }
            />
            <Route
              path="/add-service"
              element={
                <Suspense fallback={<></>}>
                  <AddService />
                </Suspense>
              }
            />
            <Route
              path="/edit-service"
              element={
                <Suspense fallback={<></>}>
                  <AddService />
                </Suspense>
              }
            />

            <Route
              path="/banners"
              element={
                <Suspense fallback={<></>}>
                  <Banner />
                </Suspense>
              }
            />
            <Route
              path="/add-banner"
              element={
                <Suspense fallback={<></>}>
                  <AddBanner />
                </Suspense>
              }
            />
            <Route
              path="/edit-banner"
              element={
                <Suspense fallback={<></>}>
                  <AddBanner />
                </Suspense>
              }
            />
            <Route
              path="/offers"
              element={
                <Suspense fallback={<></>}>
                  <Offer />
                </Suspense>
              }
            />
            <Route
              path="/add-offer"
              element={
                <Suspense fallback={<></>}>
                  <AddOffer />
                </Suspense>
              }
            />
            <Route
              path="/view-offer"
              element={
                <Suspense fallback={<></>}>
                  <ViewOffer />
                </Suspense>
              }
            />

            <Route
              path="/edit-offer"
              element={
                <Suspense fallback={<></>}>
                  <AddOffer />
                </Suspense>
              }
            />
            <Route
              path="/brands"
              element={
                <Suspense fallback={<></>}>
                  <Brand />
                </Suspense>
              }
            />
            <Route
              path="/add-brand"
              element={
                <Suspense fallback={<></>}>
                  <AddBrand />
                </Suspense>
              }
            />

            <Route
              path="/edit-brand"
              element={
                <Suspense fallback={<></>}>
                  <AddBrand />
                </Suspense>
              }
            />
            <Route
              path="/expenses"
              element={
                <Suspense fallback={<></>}>
                  <Expenses />
                </Suspense>
              }
            />
            <Route
              path="/add-expenses"
              element={
                <Suspense fallback={<></>}>
                  <AddExpenses />
                </Suspense>
              }
            />

            <Route
              path="/expense_type"
              element={
                <Suspense fallback={<></>}>
                  <ExpenseType />
                </Suspense>
              }
            />

            <Route
              path="/reports"
              element={
                <Suspense fallback={<></>}>
                  <Report />
                </Suspense>
              }
            />

            <Route
              path="/map"
              element={
                <Suspense fallback={<></>}>
                  <Map />
                </Suspense>
              }
            />

            <Route
              path="/bazaar-orders"
              element={
                <Suspense fallback={<></>}>
                  <BazaarOrder />
                </Suspense>
              }
            />

            <Route
              path="/restaurant-orders"
              element={
                <Suspense fallback={<></>}>
                  <RestaurantOrder />
                </Suspense>
              }
            />

            <Route
              path="/service-orders"
              element={
                <Suspense fallback={<></>}>
                  <SerivceOrder />
                </Suspense>
              }
            />
            <Route
              path="/order-reviews"
              element={
                <Suspense fallback={<></>}>
                  <OrderReview />
                </Suspense>
              }
            />

            <Route
              path="/order-detail"
              element={
                <Suspense fallback={<></>}>
                  <OrderDetail />
                </Suspense>
              }
            />
            <Route
              path="/static-pages"
              element={
                <Suspense fallback={<></>}>
                  <StaticPage />
                </Suspense>
              }
            />

            <Route
              path="/edit-static-page"
              element={
                <Suspense fallback={<></>}>
                  <AddStaticPage />
                </Suspense>
              }
            />

            <Route
              path="/agreement"
              element={
                <Suspense fallback={<></>}>
                  <Agreement />
                </Suspense>
              }
            />

            <Route
              path="/edit-agreement"
              element={
                <Suspense fallback={<></>}>
                  <AddAgreement />
                </Suspense>
              }
            />

            <Route
              path="/pincode"
              element={
                <Suspense fallback={<></>}>
                  <Pincode />
                </Suspense>
              }
            />

            <Route
              path="/reasons"
              element={
                <Suspense fallback={<></>}>
                  <Reason />
                </Suspense>
              }
            />

            <Route
              path="/products"
              element={
                <Suspense fallback={<></>}>
                  <Product />
                </Suspense>
              }
            />

            <Route
              path="/product-categories"
              element={
                <Suspense fallback={<></>}>
                  <ProductCategory />
                </Suspense>
              }
            />
            <Route
              path="/add-product-category"
              element={
                <Suspense fallback={<></>}>
                  <AddProductCategory />
                </Suspense>
              }
            />

            <Route
              path="/edit-product-category"
              element={
                <Suspense fallback={<></>}>
                  <AddProductCategory />
                </Suspense>
              }
            />

            <Route
              path="/add-product"
              element={
                <Suspense fallback={<></>}>
                  <AddProduct />
                </Suspense>
              }
            />

            <Route
              path="/edit-product"
              element={
                <Suspense fallback={<></>}>
                  <AddProduct />
                </Suspense>
              }
            />

            <Route
              path="/product-variant"
              element={
                <Suspense fallback={<></>}>
                  <ProductVariant />
                </Suspense>
              }
            />
            <Route
              path="/add-product-variant"
              element={
                <Suspense fallback={<></>}>
                  <AddProductVariant />
                </Suspense>
              }
            />

            <Route
              path="/edit-product-variant"
              element={
                <Suspense fallback={<></>}>
                  <AddProductVariant />
                </Suspense>
              }
            />

            <Route
              path="/import-product-variant"
              element={
                <Suspense fallback={<></>}>
                  <ImportProductVariant />
                </Suspense>
              }
            />

            <Route
              path="/import-product-variant-log"
              element={
                <Suspense fallback={<></>}>
                  <ImportProductVariantLog />
                </Suspense>
              }
            />

            <Route
              path="/product-attributes"
              element={
                <Suspense fallback={<></>}>
                  <ProductAttribute />
                </Suspense>
              }
            />

            <Route
              path="/add-product-attribute"
              element={
                <Suspense fallback={<></>}>
                  <AddProductAttribute />
                </Suspense>
              }
            />

            <Route
              path="/edit-product-attribute"
              element={
                <Suspense fallback={<></>}>
                  <AddProductAttribute />
                </Suspense>
              }
            />

            <Route
              path="/service-categories"
              element={
                <Suspense fallback={<></>}>
                  <ServiceCategory />
                </Suspense>
              }
            />

            <Route
              path="/add-service-category"
              element={
                <Suspense fallback={<></>}>
                  <AddServiceCategory />
                </Suspense>
              }
            />

            <Route
              path="/edit-service-category"
              element={
                <Suspense fallback={<></>}>
                  <AddServiceCategory />
                </Suspense>
              }
            />

            <Route
              path="/wallet"
              element={
                <Suspense fallback={<></>}>
                  <Wallet />
                </Suspense>
              }
            />

            <Route
              path="/add-wallet"
              element={
                <Suspense fallback={<></>}>
                  <AddWallet />
                </Suspense>
              }
            />

            <Route
              path="/edit-wallet"
              element={
                <Suspense fallback={<></>}>
                  <AddWallet />
                </Suspense>
              }
            />


            <Route
              path="/app-support"
              element={
                <Suspense fallback={<></>}>
                  <AppSupport />
                </Suspense>
              }
            />

            <Route
              path="/settings"
              element={
                <Suspense fallback={<></>}>
                  <Setting />
                </Suspense>
              }
            />
            <Route
              path="/app-version"
              element={
                <Suspense fallback={<></>}>
                  <AppVersion />
                </Suspense>
              }
            />

            <Route
              path="/notifications"
              element={
                <Suspense fallback={<></>}>
                  <Notification />
                </Suspense>
              }
            />

            <Route
              path="/add-notification"
              element={
                <Suspense fallback={<></>}>
                  <AddNotification />
                </Suspense>
              }
            />

            <Route
              path="/user-notifications"
              element={
                <Suspense fallback={<></>}>
                  <UserNotification />
                </Suspense>
              }
            />

            <Route
              path="/time-slots"
              element={
                <Suspense fallback={<></>}>
                  <TimeSlot />
                </Suspense>
              }
            />

            <Route
              path="/add-timeslot"
              element={
                <Suspense fallback={<></>}>
                  <AddTimeSlot />
                </Suspense>
              }
            />
            <Route
              path="/edit-timeslot"
              element={
                <Suspense fallback={<></>}>
                  <AddTimeSlot />
                </Suspense>
              }
            />

            <Route
              path="/delivery-charges"
              element={
                <Suspense fallback={<></>}>
                  <DeliveryCharges />
                </Suspense>
              }
            />

            <Route
              path="/add-delivery-charge"
              element={
                <Suspense fallback={<></>}>
                  <AddDeliveryCharges />
                </Suspense>
              }
            />
            <Route
              path="/edit-delivery-charge"
              element={
                <Suspense fallback={<></>}>
                  <AddDeliveryCharges />
                </Suspense>
              }
            />

            <Route
              path="/customer-supports"
              element={
                <Suspense fallback={<></>}>
                  <CustomerSupport />
                </Suspense>
              }
            />

            <Route
              path="/vendor-supports"
              element={
                <Suspense fallback={<></>}>
                  <VendorSupport />
                </Suspense>
              }
            />
            <Route
              path="/user_subscriptions"
              element={
                <Suspense fallback={<></>}>
                  <UserSubscription />
                </Suspense>
              }
            />
            <Route
              path="/order-refunds"
              element={
                <Suspense fallback={<></>}>
                  <OrdersRefund />
                </Suspense>
              }
            />

            <Route
              path="/delivery-boy-supports"
              element={
                <Suspense fallback={<></>}>
                  <DeliverySupport />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
